import Vue from 'vue';
import { ApartmentDTO } from '../../../model/ApartmentDTO';
import { BlockDTO } from '../../../model/BlockDTO';

export async function apartmentGalleryData(context: Vue, block: BlockDTO) {
	const apartment = context.$store.pageData.apartment as ApartmentDTO;
	let gallery = await context.$resourceService.fetchImages(block.id, "gallery", context.$store.boIdMapping);
	const galleryLocation = await context.$resourceService.fetchImages(block.id, "galleryLocation", context.$store.boIdMapping);

	if (new Date(apartment.completionDate) < new Date() && gallery.length > 0) {
		return {
			gallery
		};
	}

	gallery = [...gallery, ...galleryLocation]

	return {
		gallery
	};
}
